export default __webpack_public_path__ + "media/convenience_banner.f54e63cb.png";